<template>
  <scrollable full>
    <v-card class="mb-3">
      <v-card-title>
        {{ $t('title.settings_actions') }}
      </v-card-title>
      <v-card-text>
        <v-btn
          :disabled="isNotConnected"
          block
          large
          @click="$emit('launch-init')"
        >
          {{ $t('field.settings.do_remote_settings') }}
        </v-btn>
        <v-btn
          v-if="!isMobil && idCatalogue"
          :disabled="isNotConnected"
          class="mt-3"
          block
          large
          @click="$emit('reload-catalogue')"
        >
          {{ $t('field.settings.update_catalog') }}
        </v-btn>
        <v-btn
          v-if="IS_CISS_ANDROID"
          class="mt-3"
          block
          large
          :disabled="isNotConnected"
          @click="$emit('app-upgrade')"
        >
          {{ $t('field.settings.update_app') }}
        </v-btn>
      </v-card-text>
    </v-card>

    <scan-settings
      v-if="!offline"
      class="mb-3"
    />

    <printer-settings
      v-if="IS_ANDROID"
      class="mb-3"
    />

    <language-settings class="mb-3" />

    <password-settings
      v-if="!IS_DESKTOP"
      class="mb-3"
    />

    <common-settings
      v-if="!IS_DESKTOP"
      class="mb-3"
    />
  </scrollable>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'

import PrinterSettings from '@/components/settings/common/PrinterSettings'
import LanguageSettings from '@/components/settings/common/LanguageSettings'
import ScanSettings from '@/components/settings/common/ScanSettings'
import PasswordSettings from '@/components/settings/common/PasswordSettings'
import CommonSettings from '@/components/settings/common/CommonSettings'

export default {
  name: 'Common',

  components: {
    CommonSettings,
    PasswordSettings,
    ScanSettings,
    LanguageSettings,
    PrinterSettings
  },

  props: {
    toTab: { type: Number, default: 0 }
  },

  data () {
    return {
      IS_ANDROID,
      IS_CISS_ANDROID,
      IS_DESKTOP,
      idCatalogue: MetierLocalStorage.getCatalogueId()
    }
  },

  computed: {
    offline () { return this.$store.state.offline },
    isMobil () { return this.$store.getters.isMobil },
    isNotConnected () { return this.$store.getters.isNotConnected }
  }
}
</script>
